export default function getPostCodeRegex(country) {
  const all = [
    {
      ISO: 'AD',
      Regex: /^AD\d{3}$/,
    },
    {
      ISO: 'AE',
      Regex: /^-$/,
    },
    {
      ISO: 'AF',
      Regex: /^\d{4}$/,
    },
    {
      ISO: 'AG',
      Regex: /^-$/,
    },
    {
      ISO: 'AI',
      Regex: /^AI-\d{4}$/,
    },
    {
      ISO: 'AL',
      Regex: /^\d{4}$/,
    },
    {
      ISO: 'AM',
      Regex: /^\d{4}$/,
    },
    {
      ISO: 'AO',
      Regex: /^$/,
    },
    {
      ISO: 'AR',
      Regex: /^[A-Z]\d{4}([A-Z]{3})?$/,
    },
    {
      ISO: 'AS',
      Regex: 96799,
    },
    {
      ISO: 'AT',
      Regex: /^\d{4}$/,
    },
    {
      ISO: 'AU',
      Regex: /^\d{4}$/,
    },
    {
      ISO: 'AW',
      Regex: /^$/,
    },
    {
      ISO: 'AX',
      Regex: /^\d{5}$/,
    },
    {
      ISO: 'AZ',
      Regex: /^AZ ?\d{4}$/,
    },
    {
      ISO: 'BA',
      Regex: /^\d{5}$/,
    },
    {
      ISO: 'BB',
      Regex: /^\d{5}$/,
    },
    {
      ISO: 'BD',
      Regex: /^\d{4}$/,
    },
    {
      ISO: 'BE',
      Regex: /^\d{4}$/,
    },
    {
      ISO: 'BF',
      Regex: /^\d{5}$/,
    },
    {
      ISO: 'BG',
      Regex: /^\d{4}$/,
    },
    {
      ISO: 'BH',
      Regex: /^\d{3,4}$/,
    },
    {
      ISO: 'BI',
      Regex: /^$/,
    },
    {
      ISO: 'BJ',
      Regex: /^$/,
    },
    {
      ISO: 'BL',
      Regex: /^\d{5}$/,
    },
    {
      ISO: 'BM',
      Regex: /^[A-Z]{2}\s[\dA-Z]{2}$/,
    },
    {
      ISO: 'BN',
      Regex: /^[A-Z]{2}\d{4}$/,
    },
    {
      ISO: 'BO',
      Regex: /^$/,
    },
    {
      ISO: 'BR',
      Regex: /^\d{5}-\d{3}$/,
    },
    {
      ISO: 'BS',
      Regex: /^$/,
    },
    {
      ISO: 'BT',
      Regex: /^\d{5}$/,
    },
    {
      ISO: 'BV',
      Regex: /^$/,
    },
    {
      ISO: 'BW',
      Regex: /^$/,
    },
    {
      ISO: 'BY',
      Regex: /^2\d{5}$/,
    },
    {
      ISO: 'BZ',
      Regex: /^$/,
    },
    {
      ISO: 'CA',
      Regex: /^[A-Z]\d[A-Z]\s\d[A-Z]\d$/,
    },
    {
      ISO: 'CC',
      Regex: 6799,
    },
    {
      ISO: 'CD',
      Regex: /^\d{7}$/,
    },
    {
      ISO: 'CF',
      Regex: /^$/,
    },
    {
      ISO: 'CG',
      Regex: /^$/,
    },
    {
      ISO: 'CH',
      Regex: /^\d{4}$/,
    },
    {
      ISO: 'CI',
      Regex: /^$/,
    },
    {
      ISO: 'CK',
      Regex: /^$/,
    },
    {
      ISO: 'CL',
      Regex: /^\d{7}$/,
    },
    {
      ISO: 'CM',
      Regex: /^$/,
    },
    {
      ISO: 'CN',
      Regex: /^\d{6}$/,
    },
    {
      ISO: 'CO',
      Regex: /^\d{6}$/,
    },
    {
      ISO: 'CR',
      Regex: /^\d{5}$/,
    },
    {
      ISO: 'CU',
      Regex: /^\d{5}$/,
    },
    {
      ISO: 'CV',
      Regex: /^\d{4}-\d{3}$/,
    },
    {
      ISO: 'CW',
      Regex: /^$/,
    },
    {
      ISO: 'CX',
      Regex: 6798,
    },
    {
      ISO: 'CY',
      Regex: /^\d{4}$/,
    },
    {
      ISO: 'CZ',
      Regex: /^\d{3}\s\d{2}$/,
    },
    {
      ISO: 'DE',
      Regex: /^\d{5}$/,
    },
    {
      ISO: 'DJ',
      Regex: /^$/,
    },
    {
      ISO: 'DK',
      Regex: /^\d{4}$/,
    },
    {
      ISO: 'DM',
      Regex: /^$/,
    },
    {
      ISO: 'DO',
      Regex: /^\d{5}$/,
    },
    {
      ISO: 'DZ',
      Regex: /^\d{5}$/,
    },
    {
      ISO: 'EC',
      Regex: /^\d{6}$/,
    },
    {
      ISO: 'EE',
      Regex: /^\d{5}$/,
    },
    {
      ISO: 'EG',
      Regex: /^\d{5}(\d{2})?$/,
    },
    {
      ISO: 'ER',
      Regex: /^$/,
    },
    {
      ISO: 'ES',
      Regex: /^\d{5}$/,
    },
    {
      ISO: 'ET',
      Regex: /^$/,
    },
    {
      ISO: 'FI',
      Regex: /^\d{5}$/,
    },
    {
      ISO: 'FJ',
      Regex: /^$/,
    },
    {
      ISO: 'FK',
      Regex: /^FIQQ 1ZZ$/,
    },
    {
      ISO: 'FM',
      Regex: /^\d{5}$/,
    },
    {
      ISO: 'FO',
      Regex: /^\d{3}$/,
    },
    {
      ISO: 'FR',
      Regex: /^\d{5}$/,
    },
    {
      ISO: 'GA',
      Regex: /^$/,
    },
    {
      ISO: 'GB',
      Regex: /^[A-Z]{1,2}[0-9][A-Z0-9]?\s[0-9][A-Z]{2}$/,
    },
    {
      ISO: 'GD',
      Regex: /^$/,
    },
    {
      ISO: 'GE',
      Regex: /^\d{4}$/,
    },
    {
      ISO: 'GF',
      Regex: /^\d{5}$/,
    },
    {
      ISO: 'GG',
      Regex: /^GY\d{1,2}\s\d[A-Z]{2}$/,
    },
    {
      ISO: 'GH',
      Regex: /^[A-Z][A-Z0-9]-\d{5}-\d{4}$/,
    },
    {
      ISO: 'GI',
      Regex: /^GX11 1AA$/,
    },
    {
      ISO: 'GL',
      Regex: /^\d{4}$/,
    },
    {
      ISO: 'GM',
      Regex: /^$/,
    },
    {
      ISO: 'GN',
      Regex: /^$/,
    },
    {
      ISO: 'GP',
      Regex: /^\d{5}$/,
    },
    {
      ISO: 'GQ',
      Regex: /^$/,
    },
    {
      ISO: 'GR',
      Regex: /^\d{3}\s\d{2}$/,
    },
    {
      ISO: 'GS',
      Regex: /^SIQQ 1ZZ$/,
    },
    {
      ISO: 'GT',
      Regex: /^\d{5}$/,
    },
    {
      ISO: 'GU',
      Regex: /^\d{5}$/,
    },
    {
      ISO: 'GW',
      Regex: /^$/,
    },
    {
      ISO: 'GY',
      Regex: /^$/,
    },
    {
      ISO: 'HK',
      Regex: /^$/,
    },
    {
      ISO: 'HM',
      Regex: 7151,
    },
    {
      ISO: 'HN',
      Regex: /^$/,
    },
    {
      ISO: 'HR',
      Regex: /^\d{5}$/,
    },
    {
      ISO: 'HT',
      Regex: /^\d{4}$/,
    },
    {
      ISO: 'HU',
      Regex: /^\d{4}$/,
    },
    {
      ISO: 'ID',
      Regex: /^\d{5}$/,
    },
    {
      ISO: 'IE',
      Regex: /^[A-Z](\d{2}|6W)\s[A-Z]{4}$/,
    },
    {
      ISO: 'IL',
      Regex: /^\d{5}\s\d{2}$/,
    },
    {
      ISO: 'IM',
      Regex: /^IM\d{1,2}\s\d[A-Z]{2}$/,
    },
    {
      ISO: 'IN',
      Regex: /^\d{6}$/,
    },
    {
      ISO: 'IO',
      Regex: /^BBND 1ZZ$/,
    },
    {
      ISO: 'IQ',
      Regex: /^\d{5}$/,
    },
    {
      ISO: 'IR',
      Regex: /^\d{10}$/,
    },
    {
      ISO: 'IS',
      Regex: /^\d{3}$/,
    },
    {
      ISO: 'IT',
      Regex: /^\d{5}$/,
    },
    {
      ISO: 'JE',
      Regex: /^JE\d\s\d[A-Z]{2}$/,
    },
    {
      ISO: 'JM',
      Regex: /^$/,
    },
    {
      ISO: 'JO',
      Regex: /^\d{5}$/,
    },
    {
      ISO: 'JP',
      Regex: /^\d{3}-\d{4}$/,
    },
    {
      ISO: 'KE',
      Regex: /^\d{5}$/,
    },
    {
      ISO: 'KG',
      Regex: /^\d{6}$/,
    },
    {
      ISO: 'KH',
      Regex: /^\d{6}$/,
    },
    {
      ISO: 'KI',
      Regex: /^KI0\d{3}$/,
    },
    {
      ISO: 'KM',
      Regex: /^$/,
    },
    {
      ISO: 'KN',
      Regex: /^$/,
    },
    {
      ISO: 'KP',
      Regex: /^$/,
    },
    {
      ISO: 'KR',
      Regex: /^\d{5}$/,
    },
    {
      ISO: 'KW',
      Regex: /^\d{5}$/,
    },
    {
      ISO: 'KY',
      Regex: /^KY\d-\d{4}$/,
    },
    {
      ISO: 'KZ',
      Regex: /^[A-Z]\d{2}[A-Z]\d[A-Z]\d$/,
    },
    {
      ISO: 'LA',
      Regex: /^\d{5}$/,
    },
    {
      ISO: 'LB',
      Regex: /^\d{4}\s\d{4}$/,
    },
    {
      ISO: 'LC',
      Regex: /^LC\d{2}\s\d{3}$/,
    },
    {
      ISO: 'LI',
      Regex: /^\d{4}$/,
    },
    {
      ISO: 'LK',
      Regex: /^\d{5}$/,
    },
    {
      ISO: 'LR',
      Regex: /^\d{4}$/,
    },
    {
      ISO: 'LS',
      Regex: /^\d{3}$/,
    },
    {
      ISO: 'LT',
      Regex: /^\d{5}$/,
    },
    {
      ISO: 'LU',
      Regex: /^\d{4}$/,
    },
    {
      ISO: 'LV',
      Regex: /^\d{4}$/,
    },
    {
      ISO: 'LY',
      Regex: /^\d{5}$/,
    },
    {
      ISO: 'MA',
      Regex: /^\d{5}$/,
    },
    {
      ISO: 'MC',
      Regex: /^9800\d$/,
    },
    {
      ISO: 'MD',
      Regex: /^\d{4}$/,
    },
    {
      ISO: 'ME',
      Regex: /^\d{5}$/,
    },
    {
      ISO: 'MF',
      Regex: /^\d{5}$/,
    },
    {
      ISO: 'MG',
      Regex: /^\d{3}$/,
    },
    {
      ISO: 'MH',
      Regex: /^\d{5}$/,
    },
    {
      ISO: 'MK',
      Regex: /^\d{4}$/,
    },
    {
      ISO: 'ML',
      Regex: /^\d{5}$/,
    },
    {
      ISO: 'MM',
      Regex: /^\d{7}$/,
    },
    {
      ISO: 'MN',
      Regex: /^\d{5}$/,
    },
    {
      ISO: 'MO',
      Regex: /^$/,
    },
    {
      ISO: 'MP',
      Regex: /^\d{5}$/,
    },
    {
      ISO: 'MQ',
      Regex: /^\d{5}$/,
    },
    {
      ISO: 'MR',
      Regex: /^$/,
    },
    {
      ISO: 'MS',
      Regex: /^MSR\d{4}$/,
    },
    {
      ISO: 'MT',
      Regex: /^[A-Z]{2,3}\s\d{2,4}$/,
    },
    {
      ISO: 'MU',
      Regex: /^[\dR]\d{3,4}$/,
    },
    {
      ISO: 'MV',
      Regex: /^\d{5}$/,
    },
    {
      ISO: 'MW',
      Regex: /^\d{6}$/,
    },
    {
      ISO: 'MX',
      Regex: /^\d{5}$/,
    },
    {
      ISO: 'MY',
      Regex: /^\d{5}$/,
    },
    {
      ISO: 'MZ',
      Regex: /^\d{4}$/,
    },
    {
      ISO: 'NA',
      Regex: /^\d{5}$/,
    },
    {
      ISO: 'NC',
      Regex: /^\d{5}$/,
    },
    {
      ISO: 'NE',
      Regex: /^\d{4}$/,
    },
    {
      ISO: 'NF',
      Regex: /^28\d{2}$/,
    },
    {
      ISO: 'NG',
      Regex: /^\d{6}$/,
    },
    {
      ISO: 'NI',
      Regex: /^\d{5}$/,
    },
    {
      ISO: 'NL',
      Regex: /^\d{4}\s[A-Z]{2}$/,
    },
    {
      ISO: 'NO',
      Regex: /^\d{4}$/,
    },
    {
      ISO: 'NP',
      Regex: /^\d{5}$/,
    },
    {
      ISO: 'NR',
      Regex: /^NRU 68$/,
    },
    {
      ISO: 'NU',
      Regex: 9974,
    },
    {
      ISO: 'NZ',
      Regex: /^\d{4}$/,
    },
    {
      ISO: 'OM',
      Regex: /^\d{3}$/,
    },
    {
      ISO: 'PA',
      Regex: /^$/,
    },
    {
      ISO: 'PE',
      Regex: /^\d{5}$/,
    },
    {
      ISO: 'PF',
      Regex: /^\d{5}$/,
    },
    {
      ISO: 'PG',
      Regex: /^\d{3}$/,
    },
    {
      ISO: 'PH',
      Regex: /^\d{4}$/,
    },
    {
      ISO: 'PK',
      Regex: /^\d{5}$/,
    },
    {
      ISO: 'PL',
      Regex: /^\d{2}-\d{3}$/,
    },
    {
      ISO: 'PM',
      Regex: /^\d{5}$/,
    },
    {
      ISO: 'PN',
      Regex: /^PCRN 1ZZ$/,
    },
    {
      ISO: 'PR',
      Regex: /^\d{5}$/,
    },
    {
      ISO: 'PS',
      Regex: /^P\d{3}\s\d{4}$/,
    },
    {
      ISO: 'PT',
      Regex: /^\d{4}-\d{3}$/,
    },
    {
      ISO: 'PW',
      Regex: /^969\d{2}$/,
    },
    {
      ISO: 'PY',
      Regex: /^\d{6}$/,
    },
    {
      ISO: 'QA',
      Regex: /^$/,
    },
    {
      ISO: 'RE',
      Regex: /^\d{5}$/,
    },
    {
      ISO: 'RO',
      Regex: /^\d{6}$/,
    },
    {
      ISO: 'RS',
      Regex: /^\d{5}$/,
    },
    {
      ISO: 'RU',
      Regex: /^\d{6}$/,
    },
    {
      ISO: 'RW',
      Regex: /^$/,
    },
    {
      ISO: 'SA',
      Regex: /^\d{5}$/,
    },
    {
      ISO: 'SB',
      Regex: /^$/,
    },
    {
      ISO: 'SC',
      Regex: /^$/,
    },
    {
      ISO: 'SD',
      Regex: /^$/,
    },
    {
      ISO: 'SE',
      Regex: /^\d{3}\s\d{2}$/,
    },
    {
      ISO: 'SG',
      Regex: /^\d{6}$/,
    },
    {
      ISO: 'SH',
      Regex: /^[A-Z]{4}\s1ZZ$/,
    },
    {
      ISO: 'SI',
      Regex: /^\d{4}$/,
    },
    {
      ISO: 'SJ',
      Regex: /^\d{4}$/,
    },
    {
      ISO: 'SK',
      Regex: /^\d{3}\s\d{2}$/,
    },
    {
      ISO: 'SL',
      Regex: /^$/,
    },
    {
      ISO: 'SM',
      Regex: /^\d{5}$/,
    },
    {
      ISO: 'SN',
      Regex: /^\d{5}$/,
    },
    {
      ISO: 'SO',
      Regex: /^$/,
    },
    {
      ISO: 'SR',
      Regex: /^$/,
    },
    {
      ISO: 'SS',
      Regex: /^$/,
    },
    {
      ISO: 'ST',
      Regex: /^$/,
    },
    {
      ISO: 'SV',
      Regex: /^\d{5}$/,
    },
    {
      ISO: 'SX',
      Regex: /^$/,
    },
    {
      ISO: 'SY',
      Regex: /^$/,
    },
    {
      ISO: 'SZ',
      Regex: /^[A-Z]\d{3}$/,
    },
    {
      ISO: 'TC',
      Regex: /^TKCA 1ZZ$/,
    },
    {
      ISO: 'TD',
      Regex: /^$/,
    },
    {
      ISO: 'TF',
      Regex: /^$/,
    },
    {
      ISO: 'TG',
      Regex: /^$/,
    },
    {
      ISO: 'TH',
      Regex: /^\d{5}$/,
    },
    {
      ISO: 'TJ',
      Regex: /^\d{6}$/,
    },
    {
      ISO: 'TK',
      Regex: /^$/,
    },
    {
      ISO: 'TL',
      Regex: /^$/,
    },
    {
      ISO: 'TM',
      Regex: /^\d{6}$/,
    },
    {
      ISO: 'TN',
      Regex: /^\d{4}$/,
    },
    {
      ISO: 'TO',
      Regex: /^$/,
    },
    {
      ISO: 'TR',
      Regex: /^\d{5}$/,
    },
    {
      ISO: 'TT',
      Regex: /^\d{6}$/,
    },
    {
      ISO: 'TV',
      Regex: /^$/,
    },
    {
      ISO: 'TW',
      Regex: /^\d{6}$/,
    },
    {
      ISO: 'TZ',
      Regex: /^\d{5}$/,
    },
    {
      ISO: 'UA',
      Regex: /^\d{5}$/,
    },
    {
      ISO: 'UG',
      Regex: /^$/,
    },
    {
      ISO: 'UM',
      Regex: /^\d{5}$/,
    },
    {
      ISO: 'US',
      Regex: /^\d{5}(-\d{4})?$/,
    },
    {
      ISO: 'UY',
      Regex: /^\d{5}$/,
    },
    {
      ISO: 'UZ',
      Regex: /^\d{6}$/,
    },
    {
      ISO: 'VA',
      Regex: 120,
    },
    {
      ISO: 'VC',
      Regex: /^VC\d{4}$/,
    },
    {
      ISO: 'VE',
      Regex: /^\d{4}$/,
    },
    {
      ISO: 'VG',
      Regex: /^VG\d{4}$/,
    },
    {
      ISO: 'VI',
      Regex: /^\d{5}$/,
    },
    {
      ISO: 'VN',
      Regex: /^\d{5}$/,
    },
    {
      ISO: 'VU',
      Regex: /^$/,
    },
    {
      ISO: 'WF',
      Regex: /^\d{5}$/,
    },
    {
      ISO: 'WS',
      Regex: /^WS\d{4}$/,
    },
    {
      ISO: 'XK',
      Regex: /^$/,
    },
    {
      ISO: 'YE',
      Regex: /^$/,
    },
    {
      ISO: 'YT',
      Regex: /^\d{5}$/,
    },
    {
      ISO: 'ZA',
      Regex: /^\d{4}$/,
    },
    {
      ISO: 'ZM',
      Regex: /^$/,
    },
    {
      ISO: 'ZW',
      Regex: /^$/,
    },
  ];

  return all.filter((x) => x.ISO === country)[0]?.Regex;
}
